import React from "react";

export const getFormErrorMessage = (meta) => {
	return !!(meta.touched && meta.error) && <small className="p-error">{meta.error}</small>;
};